'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@extern/ui/button';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@extern/ui/form';
import { Input } from '@extern/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@extern/ui/select';
import { Text } from '@extern/ui/text';
import { Textarea } from '@extern/ui/textarea';
import { XIcon } from '@phosphor-icons/react';
import type { Control, UseFieldArrayRemove } from 'react-hook-form';
import { useCampaign } from '../_campaigns/use-campaign';
import { GIFT_RECIPIENTS_NAME, type GiftFormData } from '../_utils/schema';
interface RecipientFormProps {
  canRemove: boolean;
  control: Control<GiftFormData>;
  index: number;
  onRemove: UseFieldArrayRemove;
  recipientNumber: number;
}
export function RecipientForm(t0) {
  const $ = _c(37);
  const {
    index,
    control,
    onRemove,
    canRemove,
    recipientNumber
  } = t0;
  const {
    options
  } = useCampaign();
  const t1 = GIFT_RECIPIENTS_NAME[recipientNumber as keyof typeof GIFT_RECIPIENTS_NAME];
  let t2;
  if ($[0] !== t1) {
    t2 = <Text className="font-medium text-[18px] text-role-on-background leading-[24px]">{t1}</Text>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== canRemove || $[3] !== index || $[4] !== onRemove || $[5] !== recipientNumber) {
    t3 = canRemove && recipientNumber > 1 && <Button className="flex h-10 w-10 items-center justify-center" color="neutral" onClick={() => onRemove(index)} rounded="xl" type="button"><XIcon className="h-5 w-5" weight="bold" /></Button>;
    $[2] = canRemove;
    $[3] = index;
    $[4] = onRemove;
    $[5] = recipientNumber;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="flex items-center justify-between">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = `recipients.${index}.firstName`;
  let t6;
  if ($[10] !== control || $[11] !== t5) {
    t6 = <FormField control={control} name={t5} render={_temp} />;
    $[10] = control;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = `recipients.${index}.lastName`;
  let t8;
  if ($[13] !== control || $[14] !== t7) {
    t8 = <FormField control={control} name={t7} render={_temp2} />;
    $[13] = control;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t8) {
    t9 = <div className="grid grid-cols-1 gap-6 md:grid-cols-2">{t6}{t8}</div>;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = `recipients.${index}.email`;
  let t11;
  if ($[19] !== control || $[20] !== t10) {
    t11 = <FormField control={control} name={t10} render={_temp3} />;
    $[19] = control;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = `recipients.${index}.quantity`;
  let t13;
  if ($[22] !== options) {
    t13 = t14 => {
      const {
        field: formField_2
      } = t14;
      return <FormItem><FormLabel className="relative text-[14px] text-role-on-background leading-[20px]"><span className="absolute -top-0.5 -left-2 text-role-error">*</span>Gift amount</FormLabel><FormControl><Select onValueChange={value => formField_2.onChange(Number.parseInt(value, 10))} value={formField_2.value?.toString()}><SelectTrigger><SelectValue placeholder="Select gift amount" /></SelectTrigger><SelectContent>{options.map(_temp4)}</SelectContent></Select></FormControl><Text className="text-[12px] text-role-on-background-subtle">Guaranteed acceptance to all externships</Text><FormMessage /></FormItem>;
    };
    $[22] = options;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== control || $[25] !== t12 || $[26] !== t13) {
    t14 = <FormField control={control} name={t12} render={t13} />;
    $[24] = control;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  const t15 = `recipients.${index}.message`;
  let t16;
  if ($[28] !== control || $[29] !== t15) {
    t16 = <FormField control={control} name={t15} render={_temp5} />;
    $[28] = control;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t11 || $[32] !== t14 || $[33] !== t16 || $[34] !== t4 || $[35] !== t9) {
    t17 = <div className="space-y-6 rounded-3xl border border-role-outline-subtle bg-role-surface-container p-6">{t4}{t9}{t11}{t14}{t16}</div>;
    $[31] = t11;
    $[32] = t14;
    $[33] = t16;
    $[34] = t4;
    $[35] = t9;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  return t17;
}
function _temp5(t0) {
  const {
    field: formField_3
  } = t0;
  return <FormItem><FormLabel>Personal message <span className="text-role-on-surface-variant">(Optional)</span></FormLabel><FormControl><Textarea placeholder="I hope you enjoy it! =)" {...formField_3} maxLength={160} /></FormControl><Text className="text-[12px] text-role-on-background-subtle">{formField_3.value?.length || 0}/160 characters</Text><FormMessage /></FormItem>;
}
function _temp4(option) {
  return <SelectItem key={option.value} value={option.value.toString()}>{option.label}</SelectItem>;
}
function _temp3(t0) {
  const {
    field: formField_1
  } = t0;
  return <FormItem><FormLabel className="relative text-[14px] text-role-on-background leading-[20px]"><span className="absolute -top-0.5 -left-2 text-role-error">*</span>Email</FormLabel><FormControl><Input placeholder="Enter email address" type="email" {...formField_1} /></FormControl><FormMessage /></FormItem>;
}
function _temp2(t0) {
  const {
    field: formField_0
  } = t0;
  return <FormItem><FormLabel className="relative text-[14px] text-role-on-background leading-[20px]"><span className="absolute -top-0.5 -left-2 text-role-error">*</span>Last name</FormLabel><FormControl><Input placeholder="Enter last name" {...formField_0} /></FormControl><FormMessage /></FormItem>;
}
function _temp(t0) {
  const {
    field: formField
  } = t0;
  return <FormItem><FormLabel className="relative text-[14px] text-role-on-background leading-[20px]"><span className="absolute -top-0.5 -left-2 text-role-error">*</span>First name</FormLabel><FormControl><Input placeholder="Enter first name" {...formField} /></FormControl><FormMessage /></FormItem>;
}